import Http from '@core/fetch';
import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import { iTopChainsData, TopChainsData } from "@models/TopChainsData";

export interface OfferingChainsData extends iTopChainsData {
    chainsCount: number;
    menuItemsData: Array<{
        chainId: components["schemas"]["PlaceWithMenuItemsViewModel"]['id'];
        chainName: components["schemas"]["PlaceWithMenuItemsViewModel"]['chainName'];
        menuItems: components["schemas"]["PlaceWithMenuItemsViewModel"]['menuItems'];
    }>;
}

async function getOfferingChains(q: string): Promise<OfferingChainsData> {
    const data: components["schemas"]["PlacesWithMenuItemsViewModel"]  = await Http.get('offering chains + items + count', { SearchWord: q });

    return {
        ...new TopChainsData({ apiModel: data?.chainsWithMenuItems || undefined }),
        chainsCount: data?.chainsCount || 0,
        menuItemsData: (data?.chainsWithMenuItems || []).map((i) => ({
            chainId: i.id,
            chainName: i.chainName,
            menuItems: i.menuItems,
        })),
    };
}

export function useOfferingChains(q: string) {
    return useData({
        ...new TopChainsData(),
        chainsCount: 0,
        menuItemsData: [],
    }, getOfferingChains, q);
}